import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import TableSortLabel from '@material-ui/core/TableSortLabel';

class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
      this.props.onRequestSort(event, property);
    };
  
    render() {
      const { rows, order, orderBy } = this.props;
  
      return (
        <TableHead>
          <TableRow>
            {rows.map(
              row => (
                <TableCell
                  style={{fontSize: 14}}
                  key={row.id}
                  colSpan={row.span || 1}
                  align={row.align ? row.align : (row.numeric ? 'right' : 'center')}
                  padding={row.disablePadding ? 'none' : 'default'}
                  sortDirection={orderBy === row.id ? order : false} 
                  variant='head'>
                  { row.sortable ? 
                        <Tooltip
                            title="Sort"
                            placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                            enterDelay={300} >
                            <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={this.createSortHandler(row.id)} >
                            {row.label}
                            </TableSortLabel>
                        </Tooltip>
                        : row.label
                  }
                </TableCell>
              ),
              this,
            )}
          </TableRow>
        </TableHead>
      );
    }
  }
  
  EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rows: PropTypes.array.isRequired
  };

  export default EnhancedTableHead;